<ng-container *ngFor="let category of categoriesArray">
	<section class="category-name row text-20-bold text-sm-16-bold" [ngStyle]="{ 'border-color': colorsConfig[category] }">
		<span class="header-col" [ngClass]="categoryColumnClass"> {{ category }} </span>
		<div class="header-col" [ngClass]="dataColumnClass" *ngFor="let weight of categoryWeightMap.get(category)">
			<div class="row">
				<span class="text-align-right" [ngClass]="dataSpanClass">
					<ng-container *ngIf="weight; else zero">{{ weight | numberFormatter : 2 }}%</ng-container>
				</span>
				<div [ngClass]="dataEmptyColumnClass"></div>
			</div>
		</div>
		<ng-container *emptyPortfolio="portfolioIds">
			<span class="header-col text-align-right" [ngClass]="extraDataColumnClass">
				<!-- Empty span to add space for empty portfolio -->
			</span>
		</ng-container>
	</section>

	<ng-container *ngFor="let row of categoryIndexMap.get(category)">
		<section class="row text-14 security-container">
			<span class="ticker" [ngClass]="tickerClass"> {{ tableData.headersY[row].formattedValue }} </span>
			<ng-container *ngFor="let column of tableData.headersX; index as i">
				<span [ngClass]="descriptionColumnClass" *ngIf="tableData.cells[row][i].config.id === 'description'">
					<!-- AVOID USING METHOD CALLS, PLS REVIEW AND REMOVE THIS COMMENT/REFACTOR -->
					<a
						class="text-bold"
						[href]="populatePageUrl(row)"
						target="_blank"
						*ngIf="productIdPerTickerMap.get(tableData.headersY[row].formattedValue); else descriptionOnly"
						[attr.data-link-event]="tableData.cells[row][i].formattedValue | analyticEventEvaluatorPipe"
					>
						{{ tableData.cells[row][i].formattedValue }}
					</a>
					<ng-template #descriptionOnly> {{ tableData.cells[row][i].formattedValue }} </ng-template>
				</span>
				<div [ngClass]="dataColumnClass" *ngIf="tableData.cells[row][i].config.id === 'subAssetClass'">
					<span class="text-align-left text-14">
						{{ tableData.cells[row][i].formattedValue }}
					</span>
				</div>
				<div [ngClass]="dataColumnClass" *ngIf="tableData.cells[row][i].config.id === 'weight'">
					<div class="row">
						<span class="text-align-right text-14" [ngClass]="dataSpanClass">
							{{ tableData.cells[row][i].formattedValue }}
						</span>
						<div [ngClass]="dataEmptyColumnClass"></div>
					</div>
				</div>
			</ng-container>
			<ng-container *emptyPortfolio="portfolioIds">
				<span [ngClass]="descriptionColumnClass">
					<!-- Empty span to add space for empty portfolio -->
				</span>
			</ng-container>
		</section>

		<section class="row text-12 no-margin">
			<pi-alert
				*ngIf="showSecurityNotTradableAlert(row); else securityPadding"
				[ngClass]="categoryColumnClass"
				[text]="'This product is not available for trading at your firm.' | dcr : 'SECURITY_NOT_TRADABLE_HOLDING_ALERT'"
			>
			</pi-alert>
			<ng-template #securityPadding>
				<section *ngIf="showSecurityPadding(row)" [ngClass]="categoryColumnClass"></section>
			</ng-template>

			<ng-container *ngFor="let portfolio of tableData.portfolioData; let portfolioIndex = index">
				<ng-container *ngIf="portfolioSubstitutionAlerts && showSecurityPortfolioAlert(portfolioIndex); else portfolioPadding">
					<section [ngClass]="dataColumnClass" class="row text-12 no-margin">
						<pi-alert
							*ngIf="isCashSubstitutionAlert({ rowIndex: row, portfolioIndex })"
							[text]="invalidSecuritySubstitutionsAlerts[portfolioIndex]?.get((tableData?.cells)[row][this.securityIdIndex].formattedValue)"
							[infoBubble]="AlertConstants.ALERT_CASH_SUBSTITUTIONS_INFO | dcr : 'ALERT_CASH_SUBSTITUTIONS_INFO'"
						>
						</pi-alert>
						<pi-alert
							*ngIf="isSecurityAssetClassAlert({ rowIndex: row, portfolioIndex })"
							[text]="portfolioAssetSubstitutionsAlerts[portfolioIndex]?.get((tableData?.cells)[row][this.securityIdIndex].formattedValue)"
							[infoBubble]="AlertConstants.ALERT_ASSET_CLASS_OR_BOND_SUBSTITUTIONS_INFO | dcr : 'ALERT_ASSET_CLASS_OR_BOND_SUBSTITUTIONS_INFO'"
						>
						</pi-alert>
						<pi-alert
							*ngIf="isInvalidSecurityAlert({ rowIndex: row, portfolioIndex })"
							[text]="invalidSecuritySubstitutionsAlerts[portfolioIndex]?.get((tableData?.cells)[row][this.securityIdIndex].formattedValue)"
							[infoBubble]="AlertConstants.ALERT_INVALID_SECURITY_SUBSTITUTIONS_INFO | dcr : 'ALERT_INVALID_SECURITY_SUBSTITUTIONS_INFO'"
						>
						</pi-alert>
					</section>
				</ng-container>
				<ng-template #portfolioPadding>
					<section [ngClass]="dataColumnClass"></section>
				</ng-template>
			</ng-container>
		</section>
	</ng-container>
</ng-container>
<section
	*ngIf="showAssetSubstitutionsDisclosure"
	class="row row-30 col-sm-24 margin-standard disclaimer-container"
	[innerHTML]="assetSubstitutionDisclosure | dcr : 'ASSET_CLASS_SUBSTITUTION_DISCLAIMER'"
></section>
<section class="row row-30">
	<ac-disclosure [isExpandable]="false">
		<ac-tpm-disclosure></ac-tpm-disclosure>
		<div dcrHTMLKey="HOLDINGS_DISCLAIMER_CONTENT">HOLDINGS_DISCLAIMER_CONTENT</div>
	</ac-disclosure>
</section>
<ng-template #zero> <span>-</span> </ng-template>
<ng-template #loadingEllipsis>
	<span class="ellipsis-animation"> <span>.</span> <span>.</span> <span>.</span> </span>
</ng-template>
